import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { IFormELReclassification } from "../../../../Models/Forms/IFormELReclassification";
import { ILookupBase } from '../../../../Models/ILookupBase';
import { LookupService } from 'src/app/Services/LookupService';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { FormELReclassificationService } from "../../../../Services/FormELReclassificationService";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';

@Component({
  selector: 'ELReclassification',
  templateUrl: './ELReclassification.component.html',
  styleUrls: ['./ELReclassification.component.css']
})

export class FormELReclassificationComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  _lookupService: LookupService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  elReclassificationDB: IFormELReclassification;
  reportParamArray: IReportParameter[];
  _languageProficiencyTestArray: ILookupBase[];
  _elLevelArray: ILookupBase[];
  _elProficiencyDescriptorArray: ILookupBase[];
  tenYarsBack: Date;
  calendarYearRangeLastTenYears: string;

  constructor(
    private globals: Globals, reportService: ReportService,
    private _formELReclassificationService: FormELReclassificationService,
    iepService: IepService,
    lookupService: LookupService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this._lookupService = lookupService
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance
  }
  ngOnInit(): void {
    this.LoadFormELReclassificationDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.LoadLookupValues();
    this.elReclassificationDB = {} as IFormELReclassification;
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
    let today = new Date();
    this.tenYarsBack = new Date((today.getFullYear() - 10), 0, 1);
    this.calendarYearRangeLastTenYears = this.tenYarsBack.getFullYear() + ':' + today.getFullYear();
  }

  LoadFormELReclassificationDetails(): void {
    this._formELReclassificationService.getFormELReclassification(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormELReclassification) => {
        this.elReclassificationDB = res
        if (this.elReclassificationDB.currentYearTestDate != null) {
          this.elReclassificationDB.currentYearTestDate = new Date(this.elReclassificationDB.currentYearTestDate);
        }
        if (this.elReclassificationDB.priorYearTestDate != null) {
          this.elReclassificationDB.priorYearTestDate = new Date(this.elReclassificationDB.priorYearTestDate);
        }
        if (this.elReclassificationDB.assessmentDate != null) {
          this.elReclassificationDB.assessmentDate = new Date(this.elReclassificationDB.assessmentDate);
        }

        if (this.elReclassificationDB.currentYearLookupELProficiencyTestId!= null) {
          this.elReclassificationDB.currentYearLookupELProficiencyTestId = this.elReclassificationDB.currentYearLookupELProficiencyTestId.toString();
        }
        if (this.elReclassificationDB.currentYearELPACListeningProficiencyLookupId != null) {
          this.elReclassificationDB.currentYearELPACListeningProficiencyLookupId = this.elReclassificationDB.currentYearELPACListeningProficiencyLookupId.toString();
        }
        if (this.elReclassificationDB.currentYearELPACReadingProficiencyLookupId != null) {
          this.elReclassificationDB.currentYearELPACReadingProficiencyLookupId = this.elReclassificationDB.currentYearELPACReadingProficiencyLookupId.toString();
        }
        if (this.elReclassificationDB.currentYearELPACSpeakingProficiencyLookupId != null) {
          this.elReclassificationDB.currentYearELPACSpeakingProficiencyLookupId = this.elReclassificationDB.currentYearELPACSpeakingProficiencyLookupId.toString();
        }
        if (this.elReclassificationDB.currentYearELPACWritingProficiencyLookupId != null) {
          this.elReclassificationDB.currentYearELPACWritingProficiencyLookupId = this.elReclassificationDB.currentYearELPACWritingProficiencyLookupId.toString();
        }
        if (this.elReclassificationDB.priorYearLookupELProficiencyTestId != null) {
          this.elReclassificationDB.priorYearLookupELProficiencyTestId = this.elReclassificationDB.priorYearLookupELProficiencyTestId.toString();
        }
        if (this.elReclassificationDB.priorYearELPACListeningProficiencyLookupId != null) {
          this.elReclassificationDB.priorYearELPACListeningProficiencyLookupId = this.elReclassificationDB.priorYearELPACListeningProficiencyLookupId.toString();
        }
        if (this.elReclassificationDB.priorYearELPACReadingProficiencyLookupId != null) {
          this.elReclassificationDB.priorYearELPACReadingProficiencyLookupId = this.elReclassificationDB.priorYearELPACReadingProficiencyLookupId.toString();
        }
        if (this.elReclassificationDB.priorYearELPACSpeakingProficiencyLookupId != null) {
          this.elReclassificationDB.priorYearELPACSpeakingProficiencyLookupId = this.elReclassificationDB.priorYearELPACSpeakingProficiencyLookupId.toString();
        }
        if (this.elReclassificationDB.priorYearELPACWritingProficiencyLookupId != null) {
          this.elReclassificationDB.priorYearELPACWritingProficiencyLookupId = this.elReclassificationDB.priorYearELPACWritingProficiencyLookupId.toString();
        }
        if (this.elReclassificationDB.ssid == null || this.elReclassificationDB.ssid == '') {
          this.elReclassificationDB.ssid = this._myGlobals.selectedStudent.ssid;
        }

      },
        err => console.error(err)
      );
  }

  LoadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ELLanguageProficiencyTest]).subscribe((res: ILookupBase[]) => {
      this._languageProficiencyTestArray = [] as ILookupBase[];
      this._languageProficiencyTestArray.push({ label: 'Select the Language Proficiency Test', value: null, shortText: 'Select the Language Proficiency Test', updatedOn: null });
      this._languageProficiencyTestArray.push.apply(this._languageProficiencyTestArray, res);
      this._languageProficiencyTestArray.length = this._languageProficiencyTestArray.length - 1;  // Per Liz during UAT - she said that the CAA test should not be included
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ELLevel]).subscribe((res: ILookupBase[]) => {
      this._elLevelArray = [] as ILookupBase[];
      this._elLevelArray.push({ label: 'Select an EL Level', value: null, shortText: 'Select an EL Level', updatedOn: null });
      this._elLevelArray.push.apply(this._elLevelArray, res);
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ELProficiencyDescriptor]).subscribe((res: ILookupBase[]) => {
      this._elProficiencyDescriptorArray = [] as ILookupBase[];
      this._elProficiencyDescriptorArray.push({ label: 'Select an EL Proficiency', value: null, shortText: 'Select an EL Proficiency', updatedOn: null });
      this._elProficiencyDescriptorArray.push.apply(this._elProficiencyDescriptorArray, res);
    },
      err => console.error(err)
    );

  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the EL Reclassification
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values

    if (this.elReclassificationDB.ssid == null || this.elReclassificationDB.ssid == '') {
      this.elReclassificationDB.ssid = this._myGlobals.selectedStudent.ssid;
    }

    this._formELReclassificationService.insertUpdateFormELReclassification(this.elReclassificationDB)
      .subscribe((res: IFormELReclassification) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.LoadFormELReclassificationDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormELReclassificationDetails();
  }


  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'FormInstanceID', parameterValue: this.elReclassificationDB.iepFormInstanceId.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'BlankForm', parameterValue: 'False' },
      { parameterName: 'ShowWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False' },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.elReclassificationDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.elReclassificationDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
